// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the AI Chatbot Icon.
 * @param {IconProps} props - The IconProps for the AiChatbotIcon component.
 * @returns {ReactElement} The AiChatbotIcon component.
 */
export const AiChatbotIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon
      width='300'
      height='300'
      viewBox='0 0 300 300'
      color={color}
      fill='transparent'
      {...rest}
      id='ai-chatbot-icon'
    >
      <path
        d='M260.54,88.44v128.94c0,10.58-7.95,19.15-17.75,19.15H100.32c-4.03,0-7.94,1.48-11.09,4.2l-50.55,43.62c-11.62,10.03-28.84,1.1-28.84-14.96V102.5c0-10.58,7.95-19.15,17.75-19.15h173.65'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='15.61'
      />
      <path
        d='M231.76,14.72l-16.57,30.37c-.8,1.47-2.14,2.56-3.74,3.04l-33.12,10c-5.4,1.63-6.16,8.96-1.21,11.67l30.37,16.57c1.47.8,2.56,2.14,3.04,3.74l10,33.12c1.63,5.4,8.96,6.16,11.67,1.21l16.57-30.37c.8-1.47,2.14-2.56,3.74-3.04l33.12-10c5.4-1.63,6.16-8.96,1.21-11.67l-30.37-16.57c-1.47-.8-2.56-2.14-3.04-3.74l-10-33.12c-1.63-5.4-8.96-6.16-11.67-1.21Z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='16.52'
      />
      <path
        d='M154.43,114.28l-1.55,20.01c-.07.97-.53,1.86-1.26,2.5l-15.15,13.17c-2.47,2.15-1.13,6.21,2.13,6.46l20.01,1.55c.97.07,1.86.53,2.5,1.26l13.17,15.15c2.15,2.47,6.21,1.13,6.46-2.13l1.55-20.01c.07-.97.53-1.86,1.26-2.5l15.15-13.17c2.47-2.15,1.13-6.21-2.13-6.46l-20.01-1.55c-.97-.07-1.86-.53-2.5-1.26l-13.17-15.15c-2.15-2.47-6.21-1.13-6.46,2.13Z'
        fill='currentColor'
      />
    </Icon>
  );
};
